module.exports = __webpack_public_path__ + "img/asmak-wadi-el-nile.8768b496.jpg";